module.exports = __webpack_public_path__ + "img/logo-techo-web.0263331b.jpg";